import { useEffect } from "react";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { BrowserUtils } from "@azure/msal-browser";
import { Redirect } from "react-router-dom";

export const Logout = () => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.logoutRedirect({
      onRedirectNavigate: () => !BrowserUtils.isInIframe(),
    });
  }, [instance]);

  return (
    <>
      <AuthenticatedTemplate>Logging Out</AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Redirect to="/login" />
      </UnauthenticatedTemplate>
    </>
  );
};
